<script>
export default {
  name: "data-table-actions",
  props: {
    deleteWarning: String,
    isEdit: Boolean,
  },
  data: function() {
    return {
      modalVisible: this.isEdit || false,
    };
  },
  methods: {
    onModalClose: function() {
      this.onHideActions();
    },
    onDelete: function() {
      var canDelete = confirm(this.deleteWarning);
      if (canDelete) {
        this.$emit("delete");
        this.onHideActions();
      }
    },
    onEdit: function() {
      this.$emit("edit");
      this.onHideActions();
    },
    onHideActions: function() {
      this.$emit("hideActions");
    },
  },
  watch: {
    isEdit: function(val) {
      this.modalVisible = val;
    },
  },
};
</script>
<template>
  <div>
    <b-modal id="data-table-actions" v-model="modalVisible" v-on:hidden="onModalClose" :hide-footer="true" :hide-header="true" :centered="true">
      <div class="row">
        <div class="col-lg-12">
          <div style="padding:5px;">
            <button type="button" class="btn btn-light btn-round" v-on:click="onEdit()">Edit</button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div style="padding:5px;">
            <button type="button" class="btn btn-danger btn-round" v-on:click="onDelete()">Delete</button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<style scoped>
.btn {
  width: 100%;
}
</style>
